window.initPlayer = false;
window.playerSet = null;
window.playerUrls = [];
window.currentplayerUrls = [];

window.dsPlayer = new DsFlashPlayer();

window.replayurl = function () {
    var ret = dsPlayer.vChangeVideoUrl(playerUrls);
    if (!ret) {
        setTimeout(replayurl, 500);
    }
};

window.showPlayMsg = function (msg) {
    if (dsPlayer.vPlayerIsReady()) {
        dsPlayer.vAddPopMessage(msg);
    }
};

window.playerPause = function () {
    dsPlayer.vPause();
};

window.playerShow = function () {
    dsPlayer.vShowPlayer();
};

window.playerHide = function () {
    dsPlayer.vHidePlayer();
};

window.SetPlayer = function (set) {
    if (!initPlayer) {
        return;
    }

    vsetSwitchLigthButtonVisiable(set.show_close_open_light);
    vsetShareButtonVisiable(set.show_share);
    vsetSetPanelButtonVisiable(set.show_set_panel);
    vsetCaptionButtonVisiable(set.show_capture);
    vsetSwitchPopMessageButtonVisiable(set.show_pop_message);
    vsetPlayControlPanelStyle(set.play_control_show_style);

    vsetLogoVisiable(set.show_logo);
    vsetLogoPicture(set.logo_url);
    vsetLogoSize(set.logo_pos, set.logo_width, set.logo_height);

    vsetMarkVisiable(set.show_mark);
    vsetMarkPicture(set.mark_url);
    vsetMarkSize(set.mark_pos, set.mark_x, set.mark_y, set.mark_width, set.mark_height);
};

window.startPlay = function (content, urls, width, height) {
    var set = null;
    var isLive = false;

    var obj = {};

    // 设置模式参数
    // 模拟视频的图片文件地址
    obj.strSetModelVideoBitmap = '../player/images/HdVideo.jpg';
    // 显示比例是否为高清（16：9，1920*1080），否则为标清(5:4，720*576)
    obj.blSetModelHD = true;
    // 是否显示全局的大播放图标
    obj.blShowBigPlay = true;
    // 大播放按钮图片
    obj.strBigPlay_Normal = '../player/images/bigplay_blue.png';
    obj.strBigPlay_Over = '../player/images/bigplay_blue_high.png';

    // 播放控制面板部分
    // 播放控制面板的显示方式： 1.自动隐藏 2.始终显示 3.不显示控制面板
    obj.nPlayControlShowStyle = 1;
    if (set && set.play_control_show_style) {
        obj.nPlayControlShowStyle = set.play_control_show_style;
    }

    // 面板中的播放暂停按钮是否显示
    obj.blShowPlayPause = true;
    // 播放按钮图片
    obj.strPlay_Normal = '../player/images/play_disable.png';
    obj.strPlay_Over = '../player/images/play_blue.png';
    // 暂停按钮图片
    obj.strPause_Normal = '../player/images/pause_disable.png';
    obj.strPause_Over = '../player/images/pause_blue.png';

    // 面板中的停止按钮是否显示
    obj.blShowStop = true;
    // 停止按钮图片
    obj.strStop_Normal = '../player/images/stop_disable.png';
    obj.strStop_Over = '../player/images/stop_blue.png';

    // 面板中的当前时间是否显示
    obj.blShowCurrentTime = true;
    // 当前时间或剩余时间字体颜色
    obj.nCurrentTimeFontColor = 0xcccccc;

    // 面板中的总时长是否显示
    obj.blShowTotalTime = true;
    // 总时间字体颜色
    obj.nTotalTimeFontColor = 0x999999;

    // 面板中的声音图标是否显示
    obj.blShowSoundAndMute = true;
    // 声音按钮图片
    obj.strSound_Normal = '../player/images/volume_disable.png';
    obj.strSound_Over = '../player/images/volume_blue.png';
    // 静音按钮图片
    obj.strMute_Normal = '../player/images/volumeMute_disable.png';
    obj.strMute_Over = '../player/images/volumeMute_blue.png';

    // 面板中的音量滑动条是否显示
    obj.blShowsoundProgress = true;

    // 面板中的高标清切换是否显示
    obj.blShowSwitchVideoRatio = true;
    // 高清按钮图片
    obj.strHD_Normal = '../player/images/hd_disable.png';
    obj.strHD_Over = '../player/images/hd_blue.png';
    // 标清按钮图片
    obj.strSD_Normal = '../player/images/sd_disable.png';
    obj.strSD_Over = '../player/images/sd_blue.png';

    // 面板中的设置按钮是否显示
    obj.blShowSetPanel = true;
    if (set && set.show_set_panel) {
        obj.blShowSetPanel = set.show_set_panel;
    }
    // 设置按钮图片
    obj.strSetPanel_Normal = '../player/images/set_disable.png';
    obj.strSetPanel_Over = '../player/images/set_blue.png';

    // 面板中的截图按钮是否显示
    obj.blShowCapture = true;
    // 截图按钮图片
    obj.strCapture_Normal = '../player/images/capture_disable.png';
    obj.strCapture_Over = '../player/images/capture_blue.png';

    // 面板中的全屏按钮是否显示
    obj.blShowFullScreen = true;
    if (set && set.show_capture) {
        obj.blShowFullScreen = set.show_capture;
    }
    // 截图按钮图片
    obj.strEnterFullScreen_Normal = '../player/images/expand_disable.png';
    obj.strEnterFullScreen_Over = '../player/images/expand_blue.png';
    obj.strExitFullScreen_Normal = '../player/images/expandExit_disable.png';
    obj.strExitFullScreen_Over = '../player/images/expandExit_blue.png';

    // 面板中的logo是否显示
    obj.blShowLogo = false;
    if (set && set.show_logo) {
        obj.blShowLogo = set.show_logo;
        obj.strLogo = set.logo_path;
    }

    // logo图片
    // obj.strLogo = '../player/images/logo_test.png';

    // logo的尺寸
    obj.nLogoWidth = 30;
    obj.nLogoHeight = 30;

    if (set && set.logo_pos && set.logo_width && set.logo_height) {
        obj.strLogoPos = set.logo_pos;
        obj.nLogoWidth = set.logo_width;
        obj.nLogoHeight = set.logo_height;
    }

    // 点击logo的url
    obj.strClickLogoUrl = '';
    if (set && set.click_logo_url) {
        obj.strClickLogoUrl = set.click_logo_url;
    }

    // 面板中的弹幕按钮是否显示
    obj.blShowPopMessage = true;
    if (set && set.show_pop_message) {
        obj.blShowPopMessage = set.show_pop_message;
    }

    // 开启弹幕按钮图片
    obj.strEnablePopMessage_Normal = '../player/images/enablepopmsg_disable.png';
    obj.strEnablePopMessage_Over = '../player/images/enablepopmsg_blue.png';
    // 停止弹幕按钮图片
    obj.strDisablePopMessage_Normal = '../player/images/disablepopmsg_disable.png';
    obj.strDisablePopMessage_Over = '../player/images/disablepopmsg_blue.png';
    // 右侧面板功能部分
    // 分享按钮是否显示
    obj.blShowShare = true;
    if (set && set.show_share) {
        obj.blShowShare = set.show_share;
    }

    // 分享弹幕按钮图片
    obj.strShare_Normal = '../player/images/share_disable.png';
    obj.strShare_Over = '../player/images/share_blue.png';

    // 关灯按钮是否显示
    obj.blShowCloseOpenLight = true;
    if (set && set.show_close_open_light) {
        obj.blShowCloseOpenLight = set.show_close_open_light;
    }

    // 关灯按钮图片
    obj.strCloseLight_Normal = '../player/images/closeLight_disable.png';
    obj.strCloseLight_Over = '../player/images/closeLight_blue.png';
    // 开灯按钮图片
    obj.strOpenLight_Normal = '../player/images/openLight_disable.png';
    obj.strOpenLight_Over = '../player/images/openLight_blue.png';

    // 高宽比按钮是否显示
    obj.blShowSwitchVideoScale = true;
    // 高宽比按钮图片
    obj.strSwitchVideoScale_Normal = '../player/images/scale_disable.png';
    obj.strSwitchVideoScale_Over = '../player/images/scale_blue.png';
    // 台标、水印部分
    // 台标是否显示
    obj.blShowTB = false;
    // obj.strTB = '../player/images/tb.png';
    // 台标的alpha值
    obj.nTBAlpha = 0.8;
    // 台标的坐标
    obj.nTBx = 10;
    obj.nTBy = 10;
    // 台标的尺寸
    obj.nTBWidth = 80;
    obj.nTBHeight = 80;
    // 水印是否显示
    obj.blShowMark = false;
    if (set && set.show_mark) {
        obj.blShowMark = set.show_mark;
        obj.strMark = set.mark_path;
    }
    // obj.strMark = '../player/images/yingshanlogo.png';

    // 水印的alpha值
    obj.nMarkAlpha = 0.3;
    if (set && set.mark_alpha) {
        obj.nMarkAlpha = set.mark_alpha;
    }
    // 水印的坐标
    obj.nMarkx = 20;
    obj.nMarky = 20;
    // 水印的尺寸
    obj.nMarkWidth = 100;
    obj.nMarkHeight = 100;

    if (set && set.mark_pos && set.mark_x && set.mark_y && set.mark_width && set.mark_height) {
        obj.strMarkPos = set.mark_pos;
        obj.nMarkx = set.mark_x;
        obj.nMarky = set.mark_y;
        obj.nMarkWidth = set.mark_width;
        obj.nMarkHeight = set.mark_height;
    }

    // 颜色或者图片设置部分
    // 播放界面背景颜色(0x000000)，默认为黑色
    // obj.nBackgroundColor = 0x00ff00;
    // 控制面板颜色(0x000000)，默认为黑色
    // obj.nPlayControlPanelColor = 0xff0000;
    // 右侧功能面板颜色(0x000000)，默认为黑色
    // obj.nRightPanelColor = 0x0000ff;
    // alert信息的时候蒙版颜色
    // obj.nAlertMaskingPanelColor = 0x000000;
    // 播放控制部分
    // 整个应用程序的高宽
    obj.nAppWidth = width;
    obj.nAppHeight = height;
    // 开启的时候是否自动播放
    obj.blAutoPlay = true;
    // 定位后是否自动播放
    obj.blSeekAutoPlay = true;
    // 允许用户定位
    obj.blSeek = true;
    // 初始时静音
    obj.blInitMute = false;
    // 弹幕显示的位置（1：上	2：中	3：下 4:全屏）
    obj.popupMessagePos = 1;
    // 视频确认问题
    obj.strVideoQuestion = '';
    // 全屏是否隐藏鼠标
    obj.blHideMouseInFullScreen = true;
    // 广告部分
    // 是否开启前置广告
    obj.blShowForeAD = false;
    // 前置广告位置
    obj.strForeADPosition = 'mc';
    // 前置广告时长（秒）
    obj.nForeADDuration = 20;
    // 是否开启暂停广告
    obj.blShowPauseAD = true;
    // 暂停广告位置
    obj.strPauseADPosition = 'mc';

    var tmpallobj = {};
    var tmpobj = {};
    tmpobj.node_title = 'NeverSettle featuring David Beckham';
    tmpobj.starttime = '00:00:00'; // 开始时间点，只对插片广告有用
    tmpobj.duration = '60';
    tmpobj.clickurl = 'http://www.ds.net.cn/';
    tmpobj.field_ad_video = ['http://www.dfsxcms.cn/sites/default/files/%23NeverSettle%20featuring%20David%20Beckham.mp4', 'add1', 'add2'];

    // obj.foreADUrl = [JSON.parse(JSON.stringify(tmpobj)), JSON.parse(JSON.stringify(tmpobj))];
    // obj.pauseADUrl = [JSON.parse(JSON.stringify(tmpobj)), JSON.parse(JSON.stringify(tmpobj))];
    obj.foreADUrl = null;
    obj.pauseADUrl = null;

    // 播放主视频参数部分
    // 主视频路径，从标清到高清排序，每一个成员都是一个路径
    obj.VideoURLs = urls;
    // 视频标题
    obj.strVideoTitle = '';
    // 视频描述
    obj.strVideoDescription = '';

    // 当前播放的视频路径数组是否是一个直播路径数组
    obj.blLive = false;
    if (isLive) {
        obj.blLive = isLive;
    }

    dsPlayer.playMedia(content, ROOT + '/static/player/', obj, false);

    initPlayer = true;
};